//Home page view
import Barba from 'barba.js'
//Progressive from

const Home = Barba.BaseView.extend({
  namespace: 'home',
  screenWidth: window.innerWidth,
  onEnter(){

    $('nav ul li, .home-title').click(function(){
      $(this).addClass('active');
      $('body').removeClass('template-home');
      $('.home-title').addClass('hidden');
    });
  },
  onEnterCompleted(){

    setTimeout(function(){
      $('.home-title').removeClass('hidden');
    }, 500);

  },

  onLeave(){
    this.destroy();
  },
  $el: null,
  _construct(){
  },
  destroy(){

  }
});
export default Home;



// WEBPACK FOOTER //
// ./source/scripts/modules/barbaviews/home.js